var _ellipse, _g, _g2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginEmailLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 199,
    viewBox: "0 0 203 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.25,
    cx: 101.5,
    cy: 96.5,
    rx: 101.5,
    ry: 96.5,
    fill: "#F0F5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.5588,
    y: 49.7734,
    width: 88.6916,
    height: 105.321,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 101.676,
    width: 138.581,
    height: 92.849,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.784 110.801C169.784 107.904 161.409 101.464 145.665 85.0482C145.665 44.0799 147.078 45.7462 143.916 45.4561C123.026 44.8884 75.3612 42.4661 52.3577 48.3505C51.8854 48.3505 50.9943 49.017 50.9608 50.2821C50.6258 63.4918 50.2607 76.6799 50.6258 90.1982C50.6258 90.1982 33.2065 108.57 32.1044 110.156C31.362 111.206 30.9964 112.444 31.0593 113.695C31.0593 119.376 31.2301 191.908 31.0592 198.366C32.7409 198.633 35.2186 195.44 36.8712 195.789C36.1477 189.442 34.523 121.018 34.2014 116.281C34.9016 116.926 73.3412 151.689 74.3998 152.334C73.6025 153.068 52.1902 172.973 33.5214 189.024C34.9127 189.771 36.3911 192.048 37.7087 192.881C68.1924 167.147 101.125 136.73 101.658 136.239C105.503 140.103 164.213 190.319 165.261 191.284C138.352 192.892 58.0281 191.926 31.1153 191.284C31.7441 192.85 30.7565 196.72 31.0592 198.366C59.2774 198.813 142.373 197.953 170.497 195.789C171.897 195.789 173.294 194.824 172.946 193.537C172.577 171.959 170.132 116.917 169.784 110.801ZM99.8922 132.046C97.4636 133.681 78.9221 150.072 77.8736 149.748C72.6344 146.851 55.5099 132.367 55.8583 130.756C56.5584 125.606 54.113 57.3637 54.4614 51.8928C59.3522 50.927 81.7192 49.0756 87.6585 48.9954C99.5438 48.8349 135.186 49.6403 141.126 49.9612C141.126 50.2698 139.936 110.909 142.874 128.504C143.209 129.79 121.552 148.144 121.207 147.817C106.354 133.814 102.709 130.142 99.8922 132.046ZM124.011 150.072C132.208 144.234 151.684 125.233 164.21 115.627C166.642 150.399 167.003 169.799 167.003 186.193C159.091 179.047 168.363 187.217 124.005 150.072H124.011Z",
    fill: "#38A1FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.1021,
    y: 65.0156,
    width: 69.2903,
    height: 4.15742,
    rx: 2.07871,
    fill: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.1021,
    y: 76.1035,
    width: 69.2903,
    height: 4.15742,
    rx: 2.07871,
    fill: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.1021,
    y: 87.1895,
    width: 69.2903,
    height: 4.15742,
    rx: 2.07871,
    fill: "#F7FAFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2765_31981)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 183.865,
    cy: 43.8649,
    r: 15.1245,
    transform: "rotate(2.8784 183.865 43.8649)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.245 54.819C181.389 55.3788 182.641 55.7012 183.919 55.7655C185.198 55.8298 186.476 55.6345 187.67 55.1923C188.232 54.9494 188.758 54.6354 189.234 54.2586C189.47 54.0434 189.61 53.7486 189.626 53.4355C189.641 53.1224 189.531 52.815 189.319 52.5773C188.658 51.8698 187.945 52.2928 187.336 52.7027C184.859 54.3682 178.839 52.9809 176.517 48.1144C173.857 42.5395 177.926 35.4763 183.719 34.4309C188.824 33.5114 193.007 37.066 192.67 43.7579C192.368 49.7601 188.157 47.9533 188.48 41.5245C188.506 41.0089 185.231 37.4063 182.149 40.1949C179.796 42.3276 179.424 46.9736 182.185 48.7354C182.629 48.9855 183.121 49.1474 183.631 49.2114C184.141 49.2755 184.658 49.2404 185.153 49.1084C185.648 48.9763 186.11 48.7499 186.513 48.4424C186.915 48.135 187.249 47.7527 187.496 47.318C188.695 49.9513 191.079 50.2985 192.528 49.0315C195.067 46.8133 196.224 38.5675 191.52 34.374C188.005 31.2408 181.924 31.0514 177.408 35.1249C170.578 41.2761 171.925 51.0748 180.245 54.819ZM186.113 44.5527C185.94 45.7804 185.403 47.1018 183.9 46.9186C180.126 46.7288 184.338 38.0485 186.126 41.9749C186.284 42.8279 186.279 43.7011 186.112 44.5515L186.113 44.5527Z",
    fill: "#38A1FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2867 131.898C10.3878 131.469 9.5634 129.265 9.27921 126.223C8.99502 123.18 7.98743 123.322 7.8148 126.277C7.66213 128.856 6.53476 131.262 4.36691 131.969C2.94478 132.433 2.11217 133.166 4.54424 133.809C5.45036 133.989 6.27173 134.512 6.86819 135.287C7.46464 136.063 7.79921 137.043 7.8148 138.061C8.3045 141.135 9.15825 140.175 9.44949 137.809C9.52198 136.843 9.8538 135.923 10.4024 135.167C10.951 134.41 11.6914 133.852 12.5286 133.564C14.1821 133.101 14.8679 132.478 12.2867 131.898ZM8.63214 136.054C8.37186 135.24 7.92751 134.514 7.34143 133.944C6.75535 133.374 6.04708 132.98 5.28408 132.798C6.05739 132.563 6.76434 132.115 7.33923 131.497C7.91411 130.879 8.33826 130.109 8.57225 129.261C8.72498 130.03 9.04272 130.748 9.49869 131.353C9.95466 131.958 10.5355 132.433 11.1922 132.737C9.99411 133.452 9.08098 134.636 8.63214 136.058V136.054Z",
    fill: "#38A1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2867 23.4048C38.3878 23.0018 37.5634 20.9359 37.2792 18.0836C36.995 15.2313 35.9874 15.364 35.8148 18.1348C35.6621 20.5525 34.5348 22.8083 32.3669 23.4705C30.9448 23.9063 30.1122 24.5929 32.5442 25.1955C33.4504 25.3648 34.2717 25.8548 34.8682 26.5819C35.4646 27.309 35.7992 28.2281 35.8148 29.1824C36.3045 32.064 37.1582 31.1643 37.4495 28.9463C37.522 28.0404 37.8538 27.1777 38.4024 26.4687C38.951 25.7597 39.6914 25.2366 40.5286 24.9667C42.1821 24.5321 42.8679 23.9477 40.2867 23.4048ZM36.6321 27.3004C36.3719 26.5377 35.9275 25.8568 35.3414 25.3225C34.7554 24.7883 34.0471 24.4185 33.2841 24.2484C34.0574 24.0278 34.7643 23.6081 35.3392 23.0284C35.9141 22.4486 36.3383 21.7276 36.5722 20.9323C36.725 21.6534 37.0427 22.3259 37.4987 22.8931C37.9547 23.4603 38.5355 23.9055 39.1922 24.1912C37.9941 24.8614 37.081 25.9717 36.6321 27.304V27.3004Z",
    fill: "#38A1FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2765_31981",
    x: 165.228,
    y: 26.6142,
    width: 37.2732,
    height: 37.2737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.38581
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.38581
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2765_31981"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2765_31981",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginEmailLogo);
export default __webpack_public_path__ + "static/media/LoginEmailLogo.93dfde28484474cc430c83abbde3386b.svg";
export { ForwardRef as ReactComponent };